import React from 'react'
import { Box, Button, InputBase, makeStyles, Typography, useTheme } from "@material-ui/core";
import { useTranslate } from 'react-admin';
import { Add } from '@material-ui/icons';
const useStyles = makeStyles(theme => ({
    TextCreate: {
      fontFamily: 'UniviaPro-Bold',
      fontSize: '9px',
      fontWeight: 'bold',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 1.22,
      letterSpacing: ' 0.36px',
      color: '#ffffff',
      paddingTop: 8,
      paddingBottom: 8,
      paddingLeft: 8,
  
    },
    btnCreate: {
      fontFamily: 'UniviaPro-Bold',
      fontSize: '9px',
      fontWeight: 'bold',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 1.22,
      letterSpacing: '0.36px',
      color: theme.squareButon.bgColor,
      padding: 4
  
    },

  
  }));

const CreateInSelect = ({ name, handelCreateNew, clickOpenCreate, openCreate, handelCancelCreate, onChangValueInput, valueInput }) => {
    const translate = useTranslate();
    const classes = useStyles();
    const theme=useTheme()
    return (
      <Box>
        {
          openCreate ?
            (
              <Box display='flex' style={{ boxShadow: '0 1px 10px 0 rgba(0, 0, 0, 0.3)', backgroundColor:theme.squareButon.bgColor }} px={2} py={1}>
                <InputBase
                  value={valueInput}
                  onChange={onChangValueInput}
                  placeholder={translate(`pos.dashboard.nameAreNew`) + " " + name}
                  inputProps={{
                    style: {
                      backgroundColor: 'rgba(255, 255, 255, 0.15)',
                      paddingLeft: '5px',
                      borderRadius: '2px',
                      fontFamily: 'UniviaPro',
                      fontSize: '12px',
                      fontWeight: 'normal',
                      fontStretch: 'normal',
                      fontStyle: 'normal',
                      lineHeight: 2,
                      letterSpacing: '0.12px',
                      color: '#ffffff',
                      opacity: '0.15px',
                      borderRadius: '2px',
                    }
                  }}
                  style={{ width: '240px' }}
                />
                <Button disabled={valueInput.length === 0} style={{ borderRadius: '10px', backgroundColor: '#ffffff', margin: '0 1em' }} color='primary' size='small' onClick={() => handelCreateNew(valueInput)}>
                  <Typography className={classes.btnCreate} >  {translate(`pos.dashboard.createNew`) + " " + name}</Typography>
                </Button>
                <Box display='flex' alignItems='center'>
                  <Typography
                    className={classes.btnCancel}
                    style={{ color: 'white', cursor: 'pointer' }}
                    onClick={handelCancelCreate}>{translate(`pos.dashboard.CANCEL`)}
                  </Typography>
                </Box>
              </Box>
            )
            :
            (
              <Box alignItems='center' display='flex' alignContent='center' bgcolor={theme.squareButon.bgColor} boxShadow='0 1px 10px 0 rgba(0, 0, 0, 0.3)' px={3} py={1} style={{ cursor: !openCreate ? 'pointer' : 'none' }} onClick={clickOpenCreate}>
                <Typography className={classes.TextCreate} style={{ margin: 'auto 0' }}>{(translate(`pos.dashboard.createNew`)).toUpperCase()}</Typography>
                <Add style={{ color: 'white', marginLeft: 5, width: '13px', height: '13px' }} />
              </Box>
  
            )
        }
      </Box>
    )
  }
  export default CreateInSelect